// extracted by mini-css-extract-plugin
module.exports = {"ltr":"Reports_ltr__E_fAw","ReportsWarrper":"Reports_ReportsWarrper__36Iya","ReportsTitle":"Reports_ReportsTitle__21ByW","Reportscontainer":"Reports_Reportscontainer__1MiYW"};